exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "input.checkbox-a76ba4d5.checkbox-a76ba4d5{margin:0 10px 0 0}label.label-32d25fb6.label-32d25fb6{width:49%;display:inline-block}label.labelHorizontal-7348cac5.labelHorizontal-7348cac5{width:auto;display:block}\n", ""]);

// Exports
exports.locals = {
	"checkbox": "checkbox-a76ba4d5",
	"label": "label-32d25fb6",
	"labelHorizontal": "labelHorizontal-7348cac5"
};